export default {
  metadata: {
    version: '1.0.0',
    id: 'file-uploader-list-1.0.0',
    name: 'JDSFileUploaderList'
  },
  hierarchy: {
    container: ['jds_file_uploader_item']
  },
  base: {
    container: {
      'flex-direction': '{f_0}',
      'justify-content': '{f_1}',
      'align-items': '{f_2}',
      width: '{f_3}',
      opacity: '{f_4}',
      'background-color': '{f_5}',
      'border-radius': '{f_6}'
    },
    jds_file_uploader_item: {
      kind: 'normal',
      showDivider: true
    }
  },
  variant: {
    showDivider: {
      false: {
        jds_file_uploader_item: {
          showDivider: false
        }
      }
    }
  },
  combination: [{}],
  combination_config: [[]],
  api: {
    config: {
      showDivider: {
        values: [true, false]
      }
    },
    data: {
      container: {
        value: {
          type: 'list',
          name: 'items',
          object: {
            state: 'JDSFileUploaderItem.state',
            message: 'string'
          }
        }
      },
      jds_file_uploader_item: {
        state: {
          type: 'number',
          name: 'items.state'
        },
        message: {
          type: 'string',
          name: 'items.message'
        }
      }
    },
    events: {
      jds_file_uploader_item: {
        onClick: 'onClick'
      }
    },
    a11y: {
      container: {
        properties: {
          role: {
            value: 'list'
          }
        },
        name: 'items',
        repeating: {
          ariaLabel: 'itemAriaLabel',
          ariaDescribedby: {
            name: 'itemAriaDescribedby',
            platform: 'web,ios'
          }
        }
      },
      jds_file_uploader_item: {
        properties: {
          ariaLabel: 'items.itemAriaLabel',
          ariaDescribedby: 'items.itemAriaDescribedby'
        }
      }
    }
  }
};
